import css from 'styled-jsx/css';

export default css`
  .moduloVideos {
    display: flex;
    flex-direction: column;
    gap: 3rem;
    margin-top: 35px;
    .sectionTestimonials {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      gap: 1rem;
    }
    :global(.slick-dots li.slick-active button:before) {
      color: #019df4;
    }
    :global(.customVideo .iframe-video) {
      width: 100%;
    }
  }
  @media screen and (max-width: 768px) {
    .moduloVideos {
      flex-direction: column;
      .customVideo {
        height: 200px;
        margin-bottom: 15px;
        .iframe-video {
          width: 100%;
          height: 100%;
        }
      }
    }
  }
`;
